module.exports = __webpack_public_path__ + "img/Hybrid-D-7.f1051e2d.jpg";